import axios from "axios"

const request = axios.create({})

/**
 * 获取表单配置，直接返回接口响应体供表单渲染和审核校验使用。
 * @param {string} formId 表单 ID
 */
export async function getFormDetail(formId) {
    // 宿主页在渲染脚本加载后注入环境，因此在发起请求时读取；缺失时默认正式环境。
    const environment = window.env?._CUSTOUCH_FORM_ENV || "production"
    const formEnvironment = environment === "production" ? "cloud" : "beta"
    const response = await request.get(`https://form.${formEnvironment}.custouch.com/open/v1/form/${formId}`)
    return response.data
}
